import { render, staticRenderFns } from "./RegistroItemDialogComponent.vue?vue&type=template&id=63b543a9&scoped=true"
import script from "./RegistroItemDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistroItemDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./RegistroItemDialogComponent.vue?vue&type=style&index=0&id=63b543a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b543a9",
  null
  
)

export default component.exports